import { createClient } from '@supabase/supabase-js'

export const supabaseUrl = 'https://bhhdhetifdltrcyirsdy.supabase.co'
export const supabaseAnonKey =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJoaGRoZXRpZmRsdHJjeWlyc2R5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzU1Mjc4NTAsImV4cCI6MjA5MTEwMzg1MH0.Ra-oxAyOhA4xT3QWj_DVhtdC9tTs-P751A3odeWOrq0'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
